package com.example.hukakmp.ui

import kotlinx.browser.window
import org.w3c.dom.Element
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.events.Event

private external class HukaResizeObserver(
    callback: (entries: Array<dynamic>, observer: HukaResizeObserver) -> Unit,
) {
    fun observe(target: Element)
    fun disconnect()
}

internal fun runWhenLeafletContainerIsSized(
    container: HTMLDivElement,
    attempt: Int = 0,
    block: () -> Unit,
) {
    val minimumSize = 48
    if (container.clientWidth >= minimumSize && container.clientHeight >= minimumSize) {
        block()
        return
    }

    if (attempt >= 30) {
        block()
        return
    }

    window.setTimeout(
        {
            runWhenLeafletContainerIsSized(
                container = container,
                attempt = attempt + 1,
                block = block,
            )
        },
        50,
    )
}

internal fun attachLeafletResizeHandling(
    container: HTMLDivElement,
    map: dynamic,
    afterResize: (() -> Unit)? = null,
) {
    fun refresh() {
        if (!container.isConnected) return
        window.requestAnimationFrame { _ ->
            runCatching { map.invalidateSize(false) }
            afterResize?.invoke()
        }
    }

    val observer = HukaResizeObserver { _, _ -> refresh() }
    observer.observe(container)
    container.asDynamic().__hukaResizeObserver = observer

    val windowResizeListener: (Event) -> Unit = { refresh() }
    window.addEventListener("resize", windowResizeListener)
    container.asDynamic().__hukaWindowResizeListener = windowResizeListener

    listOf(0, 60, 180, 400, 800).forEach { delay ->
        window.setTimeout({ refresh() }, delay)
    }
}

internal fun detachLeafletResizeHandling(container: HTMLDivElement) {
    val observer = container.asDynamic().__hukaResizeObserver
    if (observer != null && observer != undefined) {
        runCatching { observer.disconnect() }
    }

    val listener = container.asDynamic().__hukaWindowResizeListener
    if (listener != null && listener != undefined) {
        runCatching { window.asDynamic().removeEventListener("resize", listener) }
    }

    container.asDynamic().__hukaResizeObserver = null
    container.asDynamic().__hukaWindowResizeListener = null
}
